import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { cpf } from "cpf-cnpj-validator";
import api from "../services/api";
import Loader from "../components/Loader";
import { Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

const RegisterScreen = ({ location, history }) => {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [numCpf, setNumCpf] = useState("");
  const [loading, setLoading] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [checkedValues, setCheckedValues] = useState({
    check1: false,
    check_lgpd: false,
  });

  const redirect = location.search ? location.search.split("=")[1] : "/";
  const userInfo = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;

  const handleClick = () => {
    history.push("/confirmed");
  };

  useEffect(() => {
    if (userInfo) {
      history.push(redirect);
    }
  }, [history, userInfo, redirect]);

  // Aceita apenas números
  const maskOnlyNumbers = (value) => {
    return value.replace(/\D/g, "");
  };

  const submitHandler = async (e) => {
    try {
      e.preventDefault();
      if (password !== confirmPassword) {
        toast.error("Senhas não conferem");
      } else {
        //setLoading(true);

        const config = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        const { data } = await api.post(
          "/api/users",
          {
            nome,
            email,
            password,
            numCpf,
          },
          config
        );
        toast.success("Verifique seu e-mail para confirmar o cadastro!");
        setTimeout(function () {
          setLoading(false);
          handleClick();
        }, 2000);
      }
    } catch (error) {
      //setLoading(false);
      const err = error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      //alert(err);    
      toast.error(err); // Isso deve exibir o toast de erro
      console.log("Error caught: ", err); // Adicione este log para verificar se a mensagem correta está sendo capturada
      //setIsVerified(false);
      setCheckedValues({
        check1: false,
        check_lgpd: false,
      });

    
    }
  };

  const handleBlur = () => {
    const resp = cpf.isValid(numCpf);
    return resp === true
      ? numCpf
      : (setNumCpf(""), toast.error(`CPF Inválido: ${numCpf}`));
  };

  function onChange(event) {
    const { id, checked } = event.target;
    const updatedCheckedValues = { ...checkedValues, [id]: checked };
    setCheckedValues(updatedCheckedValues);

    setIsVerified(updatedCheckedValues.check1 && updatedCheckedValues.check_lgpd);
  }

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <ToastContainer />
          <div className="container">
            <div className="card o-hidden border-0 shadow-lg my-5">
              <div className="card-body p-0">
                <div className="row">
                  <div className="col-lg-5 d-none d-lg-block bg-register-image"></div>
                  <div className="col-lg-7">
                    <div className="p-5">
                      <div className="text-center">
                        <h1 className="h4 text-gray-900 mb-4">
                          Criar uma conta!
                        </h1>
                      </div>

                      <form className="user" onSubmit={submitHandler}>
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control form-control-user"
                            placeholder="Seu nome"
                            value={nome}
                            onChange={(e) => setNome(e.target.value.toUpperCase())}
                            required
                          />
                        </div>
                        <div className="form-group">
                          <input
                            type="email"
                            className="form-control form-control-user"
                            placeholder="Seu e-mail"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                          />
                        </div>

                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control form-control-user"
                            placeholder="Seu CPF - Apenas números"
                            value={numCpf}
                            onBlur={handleBlur}
                            onChange={(e) =>
                              setNumCpf(maskOnlyNumbers(e.target.value))
                            }
                            maxLength="11"
                            required
                          />
                        </div>

                        <div className="form-group row">
                          <div className="col-sm-6 mb-3 mb-sm-0">
                            <input
                              type="password"
                              className="form-control form-control-user"
                              placeholder="Entre com senha"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                            />
                          </div>
                          <div className="col-sm-6">
                            <input
                              type="password"
                              className="form-control form-control-user"
                              placeholder="Repita a senha"
                              value={confirmPassword}
                              onChange={(e) =>
                                setConfirmPassword(e.target.value)
                              }
                            />
                          </div>
                        </div>

                        <div className="form-group row mt-4">
                          <div className="col-sm-4 ml-3 mb-5 mb-sm-0 ">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="check1"
                              onChange={onChange}
                            />

                            <a
                              href={
                                "https://sescalagoas.com.br/institucional/politicas"
                              }
                              target="_blank"
                              className="small"
                              rel="noreferrer"
                            >
                              Politica de Privacidade
                            </a>
                          
                          </div>
                          <div className="col-sm-8 ml-3 mb-5 mb-sm-0 ">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="check_lgpd"
                              onChange={onChange}
                            />

                            <a
                              href={
                                "https://sescalagoas.com.br/institucional/politicas"
                              }
                              target="_blank"
                              className="small"
                              rel="noreferrer"
                            >
                              Autorizo o tratamento dos meus Dados Pessoais
                            </a>
                          
                          </div>
                        </div>

                        <Button
                          type="submit"
                          className="btn btn-primary btn-user btn-block"
                          disabled={!isVerified}
                        >
                          Registrar conta
                        </Button>
                      </form>

                      <hr />
                      <div className="text-center">
                        <Link to={"/forgot-password"} className="small">
                          Esqueceu a senha?
                        </Link>
                      </div>
                      <div className="text-center">
                        <Link
                          to={
                            redirect ? `/login?redirect=${redirect}` : "/login"
                          }
                          className="small"
                        >
                          Você já possui conta? Login!
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default RegisterScreen;
